import {USER_TYPES_ROLE_ID} from 'constants'

export const is_superAdmin = (user) => !user.society_id 

// Society Roles
export const is_admin = (user) => user.society_id && user.role_id === USER_TYPES_ROLE_ID.admin
export const is_subAdmin = (user) => user.society_id && user.role_id === USER_TYPES_ROLE_ID.subAdmin
export const is_societyAdmin = (user) => is_admin(user) || is_subAdmin(user)
export const is_technician = (user) => user.society_id && user.role_id > USER_TYPES_ROLE_ID.vendor
export const is_vendor = (user) => user.society_id && user.role_id === USER_TYPES_ROLE_ID.vendor;
